
import { mapGetters } from 'vuex'
import messages from '@/config/messages'
import BtnLoader from '@/utils/BtnLoader'
import { API } from '@/services/api.service'
import Alerts from '@/components/includes/Alerts'
import { removeEmptyString } from '@/utils'

export default {
  name: 'contact',
  components: { Alerts },

  head () {
    const title = this.$t('pages.contact.seo.metaTitle')
    const description = this.$t('pages.contact.seo.metaDescription')
    return {
      title,
      meta: [
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'twitter:title', name: 'twitter:title', content: title },

        { hid: 'description', name: 'description', content: description },
        { hid: 'og:description', property: 'og:description', content: description },
        { hid: 'twitter:description', name: 'twitter:description', content: description },
      ]
    }
  },

  computed: {
    ...mapGetters({
      user: 'user/getUser',
      isAuthenticated: 'auth/isAuthenticated'
    })
  },
  data () {
    return {
      form: {
        lastname: '',
        firstname: '',
        email: '',
        tel: '',
        message: '',
        object: '',
      },
      send: false
    }
  },
  async asyncData ({ store }) {
    if (store.getters['auth/isAuthenticated']) {
      await store.dispatch('user/fetchUser')
    }
  },
  mounted () {
    this.fillForm()
  },
  watch: {
    'user' () {
      this.fillForm()
    }
  },
  methods: {
    async onSubmit () {
      const result = await this.$refs.formContact.validate()
      if (result && !this.send) {
        this.send = true
        let btnLoader = new BtnLoader('sendButton')
        btnLoader.show()
        try {
          await this.contact()
          await this.clearForm()
          await this.$store.dispatch('alert/pushSuccess', { msg: messages.contact.success })
        } catch (e) {
          await this.$store.dispatch('alert/pushError', { msg: messages.contact.error })
        }
        this.send = false
        btnLoader.hide()
      }
    },

    async contact () {
      removeEmptyString(this.form)
      return API.post('/contact', this.form)
    },

    fillForm () {
      if (!this.user) return
      this.form.email = this.user.email
      this.form.firstname = this.user.firstname
      this.form.lastname = this.user.lastname
      this.form.tel = this.user.tel
    },

    async clearForm () {
      this.form.message = ''
      this.form.tel = ''
      this.form.object = ''
      if (!this.isAuthenticated) {
        this.form.email = ''
        this.form.firstname = ''
        this.form.lastname = ''
      }
      setTimeout(() => {
        this.$refs.formContact.reset()
      }, 10)
    }
  }
}


